<template>
<transition name="modal">
    <div class="modal-mask">
        <div class="overlay" @click="$emit('close')"></div>
      <div class="modal-wrapper">
        <div class="modal-container">

          <div class="modal-header">
            <slot name="header">
              
            </slot>
          </div>

          <div class="modal-body">
            <slot name="body">
              Geen Inhoud
            </slot>
          </div>

          <div class="modal-footer">
            <slot name="footer">
            </slot>
            <button class="btn btn-outline-azure-dark" @click="$emit('close')">Sluiten</button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
    name: 'modal',
    props: ['width'],
    mounted() {
        if(this.width)
        {
            const container = document.querySelector('.modal-container');
            const body = document.querySelector('.modal-body');
            if(window.innerWidth < this.width)
            {
                container.style.width = '95%'
            } else if(window.innerWidth > this.width)
            {
                container.style.width = this.width + 'px'
            }
            body.style.maxHeight = window.innerWidth + 'px'
        }

        window.addEventListener("resize", () => {
            const container = document.querySelector('.modal-container');
            const body = document.querySelector('.modal-body');
            if(window.innerWidth <= 600)     
            {
                container.style.width = '95%'
            } else if(!!this.width && window.innerWidth > this.width)
            {
                container.style.width = this.width + 'px'
            } else if(!!this.width && window.innerWidth < this.width)
            {
                container.style.width = '95%'
            }
            body.style.maxHeight = window.innerWidth + 'px'
        });

    },
    watch: {
        width(value) {
            if(window.innerWidth > 600)
            {
                const container = document.querySelector('.modal-container');
                container.style.width = this.width + 'px'
            }
        }
    }
}
</script>
<style scoped lang="scss">
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
  .overlay {
    height: 100%;
    width: 100%;
    z-index: -1;
    position: fixed;
  }
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 500px;
  margin: 0px auto;
  //padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
  overflow-y: auto;
  max-height: 90%;
}

@media only screen and (max-width: 768px) {
  .modal-container {
    width: 95%;
    max-height: 90%;
  }
}

.modal-header {
  color: $lightColor;
  background-color: $darkColor;
  border-radius: 2px 2px 0 0;
}

.modal-header > h1,
.modal-header > h2,
.modal-header > h3 {
    margin: 0 !important;
}

.modal-body {
    color: $darkColor;
    overflow: auto;
}

.modal-default-button {
  float: right;
}

.modal-footer {
  margin: 0px 0px 0px 0px;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

</style>